import React from 'react';
import { Link } from 'react-router-dom';

const AboutSection = () => {
  return (
    <section className="about">
      <div className="container">
        <div className="about-content">
          <div className="about-image">
            <img src="/about.jpg" alt="About Fast Track College" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '10px' }} />
          </div>
          <div className="about-text">
            <h2>About Fast Track College of Business, Healthcare and Technology</h2>
            <p>
              Fast Track College of Business, Healthcare and Technology is committed to providing exceptional education that prepares students 
              for successful careers and meaningful lives. With a rich history of academic excellence, 
              we offer a wide range of programs designed to meet the evolving needs of today's learners.
            </p>
            <p>
              Our institution is known for its innovative teaching methods, experienced faculty, and 
              state-of-the-art facilities. We believe in nurturing not just academic skills, but also 
              critical thinking, creativity, and leadership qualities that will serve our students 
              throughout their lives.
            </p>
            <p>
              Join us in our mission to accelerate your educational journey and achieve your dreams 
              faster with quality education and comprehensive support.
            </p>
            <Link to="/about" className="btn btn-primary">Learn More</Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
